var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58821 8.23594L11.1862 3.00394C11.2618 2.85253 11.3782 2.72517 11.5221 2.63616C11.6661 2.54715 11.832 2.5 12.0012 2.5C12.1705 2.5 12.3364 2.54715 12.4803 2.63616C12.6243 2.72517 12.7406 2.85253 12.8162 3.00394L15.4142 8.23594L21.2222 9.07994C21.3897 9.10317 21.5474 9.17303 21.6771 9.28155C21.8068 9.39007 21.9034 9.53288 21.9559 9.69367C22.0083 9.85446 22.0145 10.0268 21.9737 10.1909C21.9329 10.355 21.8468 10.5044 21.7252 10.6219L17.5232 14.6919L18.5152 20.4419C18.6422 21.1799 17.8622 21.7419 17.1952 21.3939L12.0012 18.6779L6.80621 21.3939C6.14021 21.7429 5.36021 21.1799 5.48721 20.4409L6.47921 14.6909L2.27721 10.6209C2.1562 10.5033 2.07061 10.3541 2.03018 10.1903C1.98974 10.0264 1.99609 9.85451 2.04848 9.69409C2.10088 9.53367 2.19723 9.39116 2.32658 9.28277C2.45594 9.17439 2.6131 9.10446 2.78021 9.08094L8.58821 8.23594Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/Bookmark.0fdeba334b0415d250cca4d0b1ed499b.svg";
export { ForwardRef as ReactComponent };